// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, Container, Typography } from '@mui/material';
//forms
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createMessageError } from 'src/utils/messaggeError';

// components
import { LoadingButton } from '@mui/lab';

import Page from '../../components/Page';
import LogoSiptel from 'src/assets/svgComponents/LogoSiptel';

import { toast } from 'react-toastify';

import { useNavigate, useSearchParams } from 'react-router-dom';
import PasswordField from 'src/components/inputs/PasswordField';
import { useFetch } from 'src/hooks/useFetch';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'center',

    background:
      'linear-gradient(328deg, rgba(2,0,36,1) 0%, rgba(15,5,76,1) 0%, rgba(21,12,87,1) 35%, rgba(35,26,111,1) 100%)',
  },
}));

const ContentStyle = styled('div')(({ theme }) => {
  return {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: theme.palette.mode === 'light' ? 'white' : '#161C24',
    padding: '1rem',
  };
});

const loginSchema = Yup.object().shape({
  repeat_password: Yup.string()
    .required('Campo obligatorio.')
    .oneOf([Yup.ref('password')], 'Las contraseñas no son iguales'),
  password: Yup.string()
    .required('La contraseña es obligatoria')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[*_$#@-])([A-Za-z\d*_$#@-]|[^ ]){8,15}$/,
      "Debe ser de 8 y 15 caracteres con al menos una mayúscula, minúsculas,numeros y algun caracter especial permitido como '* _ - $ # @' ",
    )
    .oneOf([Yup.ref('repeat_password')], 'Las contraseñas no son iguales'),
});

const SetPassword = () => {
  //eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  const { fetch: sendRequest, loading } = useFetch();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const formik = useFormik({
    initialValues: {
      repeat_password: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { resetForm }) => {
      const token = searchParams.get('token');
      const authToken = localStorage.getItem('authToken');
      Reflect.deleteProperty(values, 'repeat_password');
      if (authToken) {
        try {
          await sendRequest(`/usuarios/me/actualizar-contrasena`, {
            method: 'POST',
            data: { ...values },
          });
          await logout();
        } catch (error) {
          console.error(error);
          const message = createMessageError(error.message);
          if (error.statusCode >= 500) {
            toast.error(
              'Ha ocurrido un error, comuniquese con soporte si el error persiste.',
            );
          } else {
            toast.error(message);
          }
          resetForm();
        }
      } else if (token) {
        try {
          await sendRequest(`/usuarios/actualizar-contrasena`, {
            method: 'POST',
            data: { ...values, token },
          });
          toast.success('Se realizo la acción con éxito.');
          navigate('/');
          resetForm();
        } catch (error) {
          console.error(error);
          const message = createMessageError(error.message);
          if (error.statusCode >= 500) {
            toast.error(
              'Ha ocurrido un error, comuniquese con soporte si el error persiste.',
            );
          } else {
            toast.error(message);
          }
          resetForm();
        }
      } else {
        toast.error('El token no existe.');
      }
    },
  });

  return (
    <Page title="Contraseña">
      <RootStyle>
        <Container
          sx={{
            width: '40vw',
          }}
          maxWidth="sm"
        >
          <ContentStyle>
            <Stack
              direction="column"
              alignItems="center"
              sx={{ margin: 'auto auto', width: '100%' }}
            >
              <LogoSiptel height={60} />

              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 2,
                }}
              >
                <Typography variant="h5" gutterBottom>
                  Establecer Contraseña
                </Typography>
              </Box>
              <form
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
                onSubmit={formik.handleSubmit}
              >
                <Box sx={{ width: '100%' }}>
                  <Stack spacing={3}>
                    <PasswordField
                      label="Contraseña"
                      name="password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                    />
                    <PasswordField
                      label="Repetir Contraseña"
                      name="repeat_password"
                      value={formik.values.repeat_password}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.repeat_password &&
                        Boolean(formik.errors.repeat_password)
                      }
                      helperText={
                        formik.touched.repeat_password &&
                        formik.errors.repeat_password
                      }
                    />
                    <Stack
                      alignItems="center"
                      sx={{ width: '30%', alignSelf: 'center' }}
                    >
                      <LoadingButton
                        fullWidth
                        size="medium"
                        type="submit"
                        variant="contained"
                        loading={loading}
                      >
                        Enviar
                      </LoadingButton>
                    </Stack>
                  </Stack>
                </Box>
              </form>
            </Stack>
          </ContentStyle>
        </Container>

        {/* 
      <div
          style={{
            height: '58vmin',
            width: '75vmin',
            backgroundImage: `url("/assets/notebook_img.png")`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        >
        <LoginSvg height="100%" /> 
        </div>

       {mdUp && (
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Hi, Welcome Back
          </Typography>
          <Image
            visibleByDefault
            disabledEffect
            src="/assets/illustrations/illustration_login.png"
            alt="login"
          />
        </SectionStyle> */}
      </RootStyle>
    </Page>
  );
};

export default SetPassword;
